module.exports = __webpack_public_path__ + "static/media/在线语音合成).26117e0f.png";